export enum PayrollFormat {
  None = 0,
  Template = 1,
  QuickBooks = 2,
  V1 = 3,
  Custom = 4,
  CustomCSV = 5
}

export const PayrollFormatMapping: Record<PayrollFormat, string> = {
  [PayrollFormat.None]: 'None',
  [PayrollFormat.Template]: 'Template',
  [PayrollFormat.QuickBooks]: 'QuickBooks',
  [PayrollFormat.V1]: 'Transfer Format Version 1',
  [PayrollFormat.Custom]: 'Custom format for Client',
  [PayrollFormat.CustomCSV]: 'Custom CSV format for Client'
};
